import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AgreementsDateBaseDirective } from '../agreements.base';

@Component({
  selector: 'td-wb-cme-agreement',
  templateUrl: './cme-agreement.component.html',
  styleUrls: ['../agreements.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CmeAgreementComponent extends AgreementsDateBaseDirective {
}
